import EdHeader from './ed-header/ed-header.vue';
import EdFooter from './ed-footer/ed-footer.vue';
import EdHeaderInSession from './ed-header-in-session/ed-header-in-session.vue';
import EdHeaderOutSession from './ed-header-out-session/ed-header-out-session.vue';
import EdNav from './ed-nav/ed-nav.vue';
import EdNavMobile from './ed-nav-mobile/ed-nav-mobile.vue';
import EdLanguage from './ed-language/ed-language.vue';
import EdCalendar from './ed-calendar/ed-calendar.vue';
import EdMembersConnected from './ed-members-connected/ed-members-connected.component.vue';

export const CoreComponents = {
  EdHeader,
  EdFooter,
  EdHeaderInSession,
  EdHeaderOutSession,
  EdNav,
  EdNavMobile,
  EdLanguage,
  EdCalendar,
  EdMembersConnected
}